export const debounce = ( fn, wait, immediate ) => {
  let timeout
  return function () {
    const context = this
    const args = arguments
    const later = function () {
      timeout = null
      if( !immediate ) {
        fn.apply( context, args )
      }
    }
    const callnow = immediate && !timeout
    clearTimeout( timeout )
    timeout = setTimeout( later, wait )
    if( callnow ) {
      fn.apply( context, args )
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/debounce.js